const mapJsonToProps = ({ seller_status_info: sellerStatusInfo, thermometer, title_label, action }) => {
  const { rank, default_info: defaultInfo, info } = thermometer || {};

  return {
    sellerStatusInfo,
    ...(thermometer ? { thermometer: { rank, defaultInfo, info } } : null),
    title: title_label,
    action,
  };
};

export default mapJsonToProps;
